// extracted by mini-css-extract-plugin
export default {"container":"gM-z","modal":"hM-z","dimensions":"iM-z","brandName":"jM-z","productName":"kM-z","labelValue":"lM-z","recipientEmail":"mM-z","recommendedFit":"nM-z","hiddenField":"oM-z"};